import React, { ReactNode, useState } from "react";
import { Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import CustomIcon, { AssetTypes } from "../../../../../../../public/icons-v1_1";
import PathPickBasketActionIconBox from "@/features/pathpick/features/basket/components/action-panel/PathPickBasketActionIconBox";

interface Props {
  icon: AssetTypes;
  title: string;
  // 타이틀 아래 설명 영역
  description: ReactNode;
  // 우측(좁은 폭에서는 다음 줄 전체 폭) 버튼 묶음
  actions: ReactNode;
}

// 액션 패널의 행 — 연동/주문 행 공용.
// PC는 [아이콘 · 타이틀/설명 …… 버튼] 한 줄 그대로 두고, 모바일에서만 목록 위를 덜 차지하도록
// 처음에는 아이콘과 타이틀만 보이게 접어 둔다. 신청·주문은 플로팅 선택 바에서도 시작할 수 있어
// 접혀 있어도 플로우가 막히지 않는다.
function PathPickBasketActionCollapsibleRow({
  icon,
  title,
  description,
  actions,
}: Props) {
  // 좁은 폭에서는 아이콘·설명을 첫 줄에 두고 버튼 묶음은 다음 줄을 다 쓴다.
  const isMobile = useBreakpointValue(
    { base: true, md: false },
    { ssr: false }
  );
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const isBodyVisible = !isMobile || isExpanded;

  return (
    // 설명 블록은 basis 0으로 줄여야 버튼보다 먼저 줄바꿈되지 않는다.
    <Flex
      padding={"16px"}
      gap={"12px"}
      alignItems={"center"}
      flexWrap={{ base: "wrap", md: "nowrap" }}
    >
      <PathPickBasketActionIconBox src={icon} icoSize={24} />
      <Flex
        flexDirection={"column"}
        gap={"2px"}
        flex={{ base: "1 1 0", md: "0 0 auto" }}
        minWidth={0}
      >
        {isMobile ? (
          // 타이틀 줄 전체가 펼침 손잡이다.
          <Flex
            as={"button"}
            type={"button"}
            aria-expanded={isExpanded}
            gap={"8px"}
            alignItems={"center"}
            textAlign={"left"}
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            <Text
              flex={1}
              minWidth={0}
              textStyle={"body-md-bold"}
              color={"#1D1D1B"}
            >
              {title}
            </Text>
            <CustomIcon
              src={isExpanded ? "chevron-up" : "chevron-down"}
              width={16}
              height={16}
              color={"#8F8F8C"}
            />
          </Flex>
        ) : (
          <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
            {title}
          </Text>
        )}
        {isBodyVisible && description}
      </Flex>
      <Flex flex={1} display={{ base: "none", md: "flex" }} />
      {isBodyVisible && actions}
    </Flex>
  );
}

export default PathPickBasketActionCollapsibleRow;
